import Link from 'next/link';
import { FaExternalLinkAlt } from 'react-icons/fa';

import styles from './footer.component.module.scss';

interface Props {
  isWithBottomMargin?: boolean;
  bottomMarginSize?: 'md' | 'lg';
}

export const FooterComponent = ({
  isWithBottomMargin = false,
  bottomMarginSize = 'md',
}: Props) => (
  <footer
    className={
      isWithBottomMargin
        ? bottomMarginSize === 'md'
          ? styles.footerWithMediumMargin
          : styles.footerWithLargeMargin
        : ''
    }
  >
    <div className={styles.footerContent}>
      <div className={styles.footerLogo}>
        <Link href="/">Findy</Link>
      </div>
      <ul className={styles.footerList}>
        <li>
          <a href="https://findy.co.jp" rel="noopener" target="_blank">
            運営企業
            <FaExternalLinkAlt
              aria-hidden="true"
              size="9px"
              style={{ verticalAlign: 'baseline', marginLeft: '2px' }}
            />
          </a>
        </li>
        <li>
          <Link href="/companies">掲載企業一覧</Link>
        </li>
        <li>
          <Link href="/terms">利用規約</Link>
        </li>
        <li>
          <Link
            href="https://findy.co.jp/privacy"
            rel="noopener"
            target="_blank"
          >
            プライバシーポリシー
            <FaExternalLinkAlt
              aria-hidden="true"
              size="9px"
              style={{ verticalAlign: 'baseline', marginLeft: '2px' }}
            />
          </Link>
        </li>
        <li>
          <a href="https://form.run/@findy-code">お問い合わせ</a>
        </li>
      </ul>
    </div>
  </footer>
);
